// mostly stolen from https://github.com/morajabi/styled-media-query
import { css } from '@emotion/react';
import rem from './rem';
export const breakpointNames = {
    default: 'default',
    extraLarge: 'extraLarge',
    extraSmall: 'extraSmall',
    large: 'large',
    medium: 'medium',
    small: 'small',
};
export const defaultBreakpointsPixels = {
    default: 0,
    extraLarge: 1440,
    extraSmall: 340,
    large: 1280,
    medium: 960,
    small: 600,
};
export const defaultBreakpoints = {
    default: defaultBreakpointsPixels.default.toString(),
    extraLarge: rem(defaultBreakpointsPixels.extraLarge),
    extraSmall: rem(defaultBreakpointsPixels.extraSmall),
    large: rem(defaultBreakpointsPixels.large),
    medium: rem(defaultBreakpointsPixels.medium),
    small: rem(defaultBreakpointsPixels.small),
};
export const generateBreakpointsList = (breakpoints) => (Object
    .entries(breakpoints)
    .map(([breakpointName, breakpointValueString,]) => ({
    breakpointName,
    breakpointValue: (Number(breakpointValueString
        .replace(
    // match any number of digits & decimals as the first group, followed by any other characters
    // replace the entire string with the first group of digits & decimals
    /^([\d.]+).*$/, '$1')) * 16),
}))
    .slice()
    .sort((breakpointA, breakpointB) => (breakpointA.breakpointValue - breakpointB.breakpointValue)));
const getSizeFromBreakpoint = (breakpoint, breakpoints) => {
    if (typeof breakpoint === 'number') {
        return `${breakpoint}`;
    }
    if (breakpoints[breakpoint]) {
        return breakpoints[breakpoint];
    }
    return breakpoint;
};
/**
 * @deprecated This utility is deprecated.
 */
export const generateMedia = (breakpoints) => {
    const lessThan = (breakpoint) => (...args) => (css `
      @media (max-width: ${getSizeFromBreakpoint(breakpoint, breakpoints)}) {
        ${css(...args)}
      }
    `);
    const greaterThan = (breakpoint) => (...args) => (css `
      @media (min-width: ${getSizeFromBreakpoint(breakpoint, breakpoints)}) {
        ${css(...args)}
      }
    `);
    const between = (firstBreakpoint, secondBreakpoint) => (...args) => (css `
      @media (min-width: ${getSizeFromBreakpoint(firstBreakpoint, breakpoints)}) and (max-width: ${(Number(getSizeFromBreakpoint(secondBreakpoint, breakpoints).replace('rem', '')) - 1).toString().concat('rem')}) {
        ${css(...args)}
      }
    `);
    return {
        between,
        greaterThan,
        lessThan,
    };
};
/* eslint-disable-next-line deprecation/deprecation */
export default generateMedia(defaultBreakpoints);
